import Log from "utils/log";
import createAsyncAction from "utils/createAsyncAction";
import { getItemAsync } from "actions/items";
import { initializeForm } from "editor/actions/form";

import { forTypeahead } from "editor/actions/metadata";

export const SEND_ALERT_REQUESTED = "SEND_ALERT_REQUESTED";
export const SEND_ALERT_SUCCEEDED = "SEND_ALERT_SUCCEEDED";
export const SEND_ALERT_FAILED = "SEND_ALERT_FAILED";

export const sendAlertAsync = createAsyncAction(
  "content",
  "sendAlert",
  "SEND_ALERT",
  ([id, alertList]) => [id, { alert_lists: alertList.map(list => list.slug) }]
);

export const GET_ALERT_LIST_REQUESTED = "GET_ALERT_LIST_REQUESTED";
export const GET_ALERT_LIST_SUCCEEDED = "GET_ALERT_LIST_SUCCEEDED";
export const GET_ALERT_LIST_FAILED = "GET_ALERT_LIST_FAILED";

// retrieve list of recipicent email lists from Sailthru
export const getAlertListAsync = createAsyncAction(
  "subscriptions",
  "list",
  "GET_ALERT_LIST",
  () => ({
    subscription_type: "alert",
  })
);

export const getAlertListAsyncForTypeahead = forTypeahead(getAlertListAsync);

// On the back-end, the Content object model requires two fields,
// alert_subject and alert_text before an alert can be sent.
// hydrateAlert sets the initial values for those fields.
// reworked from hydrateForm
export const hydrateAlert = id => {
  return dispatch => {
    return dispatch(getItemAsync(id))
      .then(action => {
        const story = action.payload;
        const state = {};

        for (let key in story) {
          switch (key) {
            case "alert_lists":
              break;

            case "id":
            case "alert_text":
            case "alert_subject":
            case "head_rev":
              state[key] = story[key];
              break;

            default:
              break;
          }
        }

        dispatch(initializeForm(state));
      })
      .catch(e => {
        Log.error(e);
      });
  };
};

export const SAVE_ALERT_REQUESTED = "SAVE_ALERT_REQUESTED";
export const SAVE_ALERT_SUCCEEDED = "SAVE_ALERT_SUCCEEDED";
export const SAVE_ALERT_FAILED = "SAVE_ALERT_FAILED";

export const saveAlertRequested = () => {
  return {
    type: SAVE_ALERT_REQUESTED,
  };
};

export const saveAlertSuccess = payload => {
  return {
    type: SAVE_ALERT_SUCCEEDED,
    payload,
  };
};

export const saveAlertFailure = error => {
  return {
    type: SAVE_ALERT_FAILED,
    payload: error,
    error: true,
  };
};

//
export const validateAlert = form => {
  const validationErrors = {};
  if (!form.alert_subject || form.alert_subject.length < 1) {
    validationErrors.alert_subject = "Please add a subject";
  }
  if (!form.alert_text || form.alert_text.length < 1) {
    validationErrors.alert_text = "Please add a body text";
  }
  if (!form.alert_lists) {
    validationErrors.alert_lists = "Please add recipients";
  }
  return validationErrors;
};

// save update the alert form
// reworked from saveFrom in status.js
export const saveAlertAsync = () => {
  return (dispatch, getState, getClient) => {
    const client = getClient(dispatch, getState);
    const {
      editor: { form, status },
    } = getState();

    const body = {};

    for (let key in form) {
      switch (key) {
        case "alert_lists":
          break;

        case "id":
        case "alert_text":
        case "alert_subject":
        case "head_rev":
          body[key] = form[key];
          break;

        default:
          break;
      }
    }

    dispatch(saveAlertRequested());

    const validationError = validateAlert(form) || false;
    return new Promise((resolve, reject) => {
      if (Object.keys(validationError).length) {
        return reject(validationError);
      } else {
        return resolve();
      }
    })
      .then(() => {
        return client.content.update(form.id, body, status.editKey);
      })
      .then(() => {
        return dispatch(saveAlertSuccess());
      })
      .catch(error => {
        // if validation error fails bubble up the alert to the component
        // this enables field-level error messaging to render
        Log.error(error);
        dispatch(saveAlertFailure(error));
        throw error;
      });
  };
};
